import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import type { OnboardingHeaderProps } from './onboarding-header.interface'

const SMS_REMINDER_BRAND = { logoSrc: '/logo.png', logoAlt: 'SMS Reminder App Logo', byline: 'by SMS Reminder' }
const KALAMA_BRAND = {
  logoSrc: '/favicon-kalama-120.png',
  logoAlt: 'Kalama (formerly SMS Reminder)',
  byline: 'by Kalama (formerly SMS Reminder)',
}

export function OnboardingHeader({ classes }: OnboardingHeaderProps) {
  const brand = isKalamaBrandingEnabled() ? KALAMA_BRAND : SMS_REMINDER_BRAND

  return (
    <div className={classes.header}>
      <div className={classes.headerContent}>
        <img src={brand.logoSrc} alt={brand.logoAlt} className={classes.logo} />
        <h1 className={classes.title}>
          <span className={classes.titleMain}>Appointment Booking</span>{' '}
          <span className={classes.titleSub}>{brand.byline}</span>
        </h1>
      </div>
    </div>
  )
}
